// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import PartRequestHeader from './part-request-header';
import SearchBox from '../../../shared/components/search-box';
import ShippingInstruction from '../../shared/components/shipping-instruction';
import {getSearchBoxPlaceholder} from '../../search/services/helpers';

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropdown.selectedOption.key, query);

}

const PartReturnsWrapper = props =>
    <section className='part-returns'>
        <div className='aside-column'>
            <aside>{props.facets}</aside>
            <aside><ShippingInstruction/></aside>
        </div>
        <main>
            <SearchBox
                defaultOption={props.searchByDropdown.selectedOption.key}
                onOptionChange={props.actions.updateSearchBy}
                onQueryChange={props.actions.updateSearchQueryString}
                onSearch={props::handleSearch}
                placeholderText={getSearchBoxPlaceholder(props.searchByDropdown.selectedOption.key)}
                queryString={props.searchQueryString}
                searchBy={props.searchByDropdown.searchBy}
            />
            <PartRequestHeader
                allPartRequestsCount={props.allPartRequestsCount}
                hasSearchResultsLoaded={props.hasSearchResultsLoaded}
                openPartRequestsCount={props.openPartRequestsCount}
                searchResultsCount={props.searchResultsCount}
            />
            {props.children}
        </main>
    </section>;

PartReturnsWrapper.displayName = 'PartReturnsWrapper';
PartReturnsWrapper.propTypes = {
    actions: PropTypes.object,
    allPartRequestsCount: PropTypes.number,
    children: PropTypes.node.isRequired,
    facets: PropTypes.node.isRequired,
    hasSearchResultsLoaded: PropTypes.bool,
    openPartRequestsCount: PropTypes.number,
    searchByDropdown: PropTypes.object,
    searchQueryString: PropTypes.string,
    searchResultsCount: PropTypes.number
};

export default PartReturnsWrapper;



// WEBPACK FOOTER //
// ./src/part-requests/shared/components/part-returns-wrapper.js